
<template>
    <views v-if="showBtn" class="scanCode">
        <views class="scanCode-content">
            <button class="btn primary" @click="handleScanCode">扫码校验</button>
            <button class="btn" @click="handleInput">手工输入数字码</button>
<!--            <button class="btn" @click="handleHome">返回首页</button>-->
        </views>
    </views>
</template>

<script>
/**
 * 微信扫描
 * 需要通过url传递4个参数 type, public, verify_record_id, public_code
 *
 * type   [String]   verify: 明暗校验 prize： 抽奖校验 trace: 追踪溯源
 * public [String]   1: 校验明码 2：校验暗码
 * verify_record_id [String] 校验明码id
 * public_code [String] 明码
 *
 */

import wx from 'weixin-jsapi'
// import api from '@/utils/api'
import tools from '@/mixins/tools'
import getLocation from '@/mixins/getLocation'
export default {
    mixins: [tools, getLocation],
    data() {
        return {
            showBtn: false
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        type() {
            return this.query.type
        },
        public() {
            return this.query.public
        }
    },
    beforeMount() {
        // this.getLocation()
    },
    mounted() {
        // this.wxScanCode()
        setTimeout(() => {
            this.showBtn = true
            // this.hideLoading()
        }, 1000)
    },
    methods: {
        wxScanCode() {
            this.loading()
            const _this = this
            wx.scanQRCode({
                needResult: '1', // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
                success: function(res) {
                    const reg = /(\d+)/g
                    var qrCode = res.resultStr.match(reg)
                    if (!qrCode) {
                        this.errMsg('二维码无效')
                        return
                    }
                    res.resultStr = qrCode[0]
                    if (_this.public === '1') {
                        _this.windowPush(`/verify?type=${_this.type}&public=${_this.public}&qrCode=${res.resultStr}`)
                    } else {
                        _this.windowPush(`/verify?type=${_this.type}&public=${_this.public}&qrCode=${res.resultStr}&verify_record_id=${_this.query.verify_record_id}&public_code=${_this.query.public_code}`)
                    }
                },
                error: function(res) {
                    this.msg(res)
                },
                complete: function(e) {
                    console.log('complete', e)
                }

            })
            this.hideLoading()
        },
        // 再次扫描
        handleScanCode() {
            // window.location.reload()
            this.wxScanCode()
        },
        // 返回首页
        handleHome() {
            this.push('/')
        },
        // 手工输入
        handleInput() {
            if (this.public === '1') {
                this.windowPush(`/verify?type=${this.type}&public=${this.public}`)
            } else {
                this.windowPush(`/verify?type=${this.type}&public=${this.public}&verify_record_id=${this.query.verify_record_id}&public_code=${this.query.public_code}`)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
